import styled from "styled-components";
import { MD_SCREEN } from "../util/screen-size";

export interface IGlassMargin{
    top: number,
    left: number; 
    bottom: number; 
    right: number; 
}

export const getStyledGlassBackground = (margin?: IGlassMargin) => styled.div`

    @media (min-width: ${MD_SCREEN}px) {
        left: 0;
    }

    display: inline-block;
    border-radius: 2%;
    position: absolute;
    background: rgba(255, 255, 255, .1);
    z-index: 5;
    ${margin
        ? `margin: ${margin.top}px ${margin.right}px ${margin.bottom}px ${margin.left}px;`
        :''
    }

    backdrop-filter: blur(30px);
    border: solid 2px transparent;
    background-clip: padding-box;
`